import { Navigate } from "react-router-dom";

// The Reports page has been merged into the Risk Report page (/risks).
// This file is kept only as a redirect so any existing bookmarks or
// external links to /reports continue to work.
// See: FIX-012 / ITEM-004

export function Reports() {
  return <Navigate to="/risks" replace />;
}
